import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApicallService } from '../services/apicall.service';

@Injectable({
  providedIn: 'root'
})
export class ForeignAgentValidationGuard  {
  
  constructor( 
    private apiCallService: ApicallService,
    private router: Router
    ){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.apiCallService.user.agentType=='I') {
        this.router.navigate(['/foreign-incentives']) 
      }
    return true;
  }
  
}
